const jsonData = [
    {
      heading: "Establishment Type",
      data: [
        { label: "Restaurant" },
        { label: "Quick Bites" },
        { label: "Dessert" },
        { label: "Coffee & Tea" },
      ],
    },
    {
      heading: "Restaurant Features",
      data: [
        { label: "Delivery" },
        { label: "Takeout" },
        { label: "Gift Cards Available" },
        { label: "Table Service" },
        { label: "Accepts Credit Cards" },
        { label: "Family style" },
        { label: "Free Wifi" },
      ],
    },
    {
      heading: "Meals",
      data: [
        { label: "Breakfast" },
        { label: "Brunch" },
        { label: "Lunch" },
        { label: "Dinner" },
      ],
    },
    {
      heading: "Cuisine",
      data: [
        { label: "American" },
        { label: "Asian" },
        { label: "Chinese" },
        { label: "Australian" },
        { label: "Italian" },
        { label: "Indian" },
        { label: "French" },
        { label: "Japanese" },
        { more: "View more" },
      ],
    },
    {
      heading: "Price",
      data: [
        { label: "Cheap Eats" },
        { label: "Mid-range" },
        { label: "Fine Dining" },
      ],
    },
    {
      heading: "Dishes",
      data: [
        { label: "Salad" },
        { label: "Fish" },
        { label: "Beef" },
        { label: "Pork" },
      ],
    },
    {
      heading: "Good For",
      data: [
        { label: "Child-friendly" },
        { label: "Kids" },
        { label: "Bar Scene" },
        { label: "Groups" },
      ],
    },
    {
      heading: "Dietary Restrictions",
      data: [
        { label: "Vegetarian Friendly" },
        { label: "Vegan Options" },
        { label: "Halal" },
        { label: "Kosher" },
      ],
    },
    {
      heading: "Neighborhoods",
      data: [
        { label: "Downtown New York" },
        { label: "Soma" },
        { label: "Mission District" },
        { label: "Theater District" },
      ],
    },
  ];
  export default jsonData;